import React from 'react'
/** @jsx jsx */
import { jsx } from 'theme-ui'

const Footer = ({}) => {
  return (
    <>
      <div className="copy-bottom bg-li py-4 border-top">
        <div className="container-fluid">
          <div className="d-md-flex px-md-3 position-relative text-center">
            <div className="social-icons-footer mb-md-0 mb-3">
              <ul className="list-unstyled">
                <li>
                  <a
                    aria-label={'Go to Twitter profile'}
                    href="https://twitter.com/BTPipeline"
                  >
                    <i
                      sx={{ color: 'primary' }}
                      className="fab fa-twitter"
                      aria-hidden="true"
                    ></i>
                  </a>
                </li>
                <li>
                  <a
                    aria-label={'Go to Instagram profile'}
                    href="https://www.instagram.com/btpipeline/?hl=en"
                  >
                    <i
                      sx={{ color: 'primary' }}
                      className="fab fa-instagram"
                      aria-hidden="true"
                    ></i>
                  </a>
                </li>
                <li>
                  <a
                    aria-label={'Move to top of the page'}
                    href="#home"
                    className="move-top text-center"
                  >
                    <i
                      sx={{ color: 'primary' }}
                      className="fa fa-level-up-alt"
                      aria-hidden="true"
                    ></i>
                  </a>
                </li>
              </ul>
            </div>

            {/* <div className="copy_right mx-md-auto mb-md-0 mb-3">
              <p className="text-bl let">
                © 2019 Runbytech. All rights reserved | Design by
                <a href="http://w3layouts.com/" target="_blank" rel="noopener noreferrer">
                  W3layouts
                </a>
              </p>
            </div> */}

            <div className="copy_right mx-md-auto mb-md-0 mb-3">
              <p className="text-bl let" sx={{ fontSize: '11px' }}>
                © 2020 Black Tech Pipeline, LLC. All rights reserved | Graphics
                by{' '}
                <a href="https://niesha-white.com/" target="_blank" rel="noopener noreferrer">
                  Niesha White
                </a>
              </p>
              <p sx={{ fontSize: '11px', color: '#343a40' }}>
                Built with passion{' '}
                <i
                  className="fas fa-heart"
                  sx={{ color: 'brown', marginRight: '2px' }}
                ></i>
                by{' '}
                <a href="https://twitter.com/ParissAthena" target="_blank" rel="noopener noreferrer">
                  Pariss Athena
                </a>
                <span> and </span>
                <a href="https://twitter.com/Dayhaysoos" target="_blank" rel="noopener noreferrer">
                  Nick DeJesus
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer
